import { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DEFAULT_EVALUATION_WEIGHT, useSaveEvaluationWeight } from "@/hooks/use-save-evaluation-weight";
import type { UserWithProfile } from "@/types/user-profile";

const MINIMUM_WEIGHT = 1;
const MAXIMUM_WEIGHT = 10;

export function EvaluationWeightInput({ user }: { user: UserWithProfile }) {
  const savedWeight = user.evaluation_weight ?? DEFAULT_EVALUATION_WEIGHT;
  const [weight, setWeight] = useState<number>(savedWeight);
  const { save, isSaving } = useSaveEvaluationWeight(user);
  const isValid = Number.isInteger(weight) && weight >= MINIMUM_WEIGHT && weight <= MAXIMUM_WEIGHT;
  const hasChanged = weight !== savedWeight;

  const handleSave = async () => {
    if (!isValid || !hasChanged) return;
    await save(weight);
  };

  return (
    <div className="flex items-center justify-end gap-1">
      <Input
        type="number"
        min={MINIMUM_WEIGHT}
        max={MAXIMUM_WEIGHT}
        value={weight}
        onChange={(event) => setWeight(Number(event.target.value))}
        onKeyDown={(event) => {
          if (event.key === "Enter") handleSave();
        }}
        aria-label={`Peso de avaliação de ${user.full_name || user.username || "usuário"}`}
        className="h-8 w-16 text-right tabular-nums"
      />
      {hasChanged && (
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8"
          onClick={handleSave}
          disabled={!isValid || isSaving}
          aria-label="Salvar peso"
          title="Salvar peso"
        >
          <Check className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
